import React from "react";

export default function AppDownload() {
  const hostname = window.location.hostname;

  const handleDownload = () => {
    let url =
      "https://play.google.com/store/apps/details?id=com.Scai.arjtechnologies";
    if (hostname.includes("tifa.arjtech.xyz")) {
      url = "https://arjtech.xyz/tifa_scai_backend/files/tifa.apk";
    }
    window.open(url, "_blank").focus();
  };
  return (
    <div className="d-flex flex-column">
      {/* Updated Header */}
      <div
        style={{
          background:
            "linear-gradient(90deg, rgba(140,87,255,0.29), rgb(169,116,255))",
          color: "#fff",
          textAlign: "center",
          padding: "20px 20px",
          borderBottomLeftRadius: "50px",
          borderBottomRightRadius: "50px",
          boxShadow: "0 4px 15px rgba(0, 0, 0, 0.2)",
        }}
      >
        <h1
          style={{
            fontSize: "3rem",
            fontWeight: "bold",
            animation: "fadeInDown 1s ease-in-out",
          }}
        >
          Download Our Apps
        </h1>
        <p style={{ fontSize: "1.4rem", marginTop: "10px" }}>
          Choose your app and download now.
        </p>
      </div>

      {/* Main Content */}
      <div className="container text-center mt-5">
        <div className="row justify-content-center g-4">
          {/* Teacher App */}
          <div className="col-md-4">
            <div
              className="card shadow-lg border-0 h-100 p-4 animate-card"
              style={{
                borderRadius: "25px",
                background: "#fff",
                overflow: "hidden",
              }}
            >
              <div className="text-center mb-4">
                <img
                  src="/assets/Images/teacher.jpg"
                  alt="teacher_App"
                  className="img-fluid"
                />
              </div>

              <h3 className="fw-bold text-primary mb-3">Teacher App</h3>
              <p className="text-muted mb-4">
                Manage classes, communicate with parents, and track student
                progress.
              </p>
              <br />
              <a
                onClick={handleDownload}
                className="btn btn-purple w-100 mb-2 fs-5 text-white"
                download
              >
                <i className="bi bi-download me-2 text-white fs-4"></i>
                Android App Download
              </a>
            </div>
          </div>

          <div className="col-md-1"></div>

          {/* Parent App */}
          <div className="col-md-4">
            <div
              className="card shadow-lg border-0 h-100 p-4 animate-card"
              style={{
                borderRadius: "25px",
                background: "#fff",
                overflow: "hidden",
              }}
            >
              <div className="text-center mb-4">
                <img
                  src="/assets/Images/parents.jpg"
                  alt="parents_app"
                  className="img-fluid"
                />
              </div>

              <h3 className="fw-bold text-primary mb-3">Parent/Student App </h3>
              <p className="text-muted mb-4">
                Track your child’s progress, receive alerts, and stay connected
                with teachers.
              </p>

              <a
                onClick={handleDownload}
                className="btn btn-purple w-100 mb-2 fs-5 text-white"
                download
              >
                <i className="bi bi-google-play me-2 fs-4 text-white"></i>{" "}
                Android App Download
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* CSS for animations and buttons */}
      <style>
        {`
          @keyframes fadeInDown {
            from {
              opacity: 0;
              transform: translateY(-20px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }

          .animate-card:hover {
            transform: scale(1.05);
            box-shadow: 0 8px 20px rgba(0,0,0,0.2);
            transition: all 0.3s ease-in-out;
          }

          .btn-purple {
            background: linear-gradient(90deg, #8c57ff, #a974ff);
            color: #fff;
            border: none;
            transition: background 0.4s;
          }
          .btn-purple:hover {
            background: linear-gradient(90deg, #a974ff, #8c57ff);
          }
        `}
      </style>
    </div>
  );
}
